import { z } from "zod";
import { AddressModelSchema } from "./AddressModel";

export enum PaymentFrequency {
  Monthly = "Monthly",
  Yearly = "Yearly",
}

export enum InvoiceFrequency {
  EndOfMonth = "EndOfMonth",
  SeventhOfMonth = "SeventhOfMonth",
  TenthOfMonth = "TenthOfMonth",
  EleventhOfMonth = "EleventhOfMonth",
  FifteenthOfMonth = "FifteenthOfMonth",
  TwentyFirstOfMonth = "TwentyFirstOfMonth",
}

export const FinalDetailsModelSchema = z.object({
  bankAccountName: z.string().nullable(),
  bankAccountNumber: z.string().nullable(),
  bankId: z.number().nullable(),
  contactNumber: z.string().nullable(),
  contactNumberComplete: z.boolean().nullable(),
  deliveryAddress: AddressModelSchema.nullable(),
  deliveryAddressComplete: z.boolean().nullable(),
  deliveryAddressText: z.string().nullable(),
  hasAcceptedTermsAndConditions: z.boolean().nullable(),
  hasBankSigningAuthority: z.boolean().nullable(),
  hasManualDeliveryAddress: z.boolean().nullable(),
  invoiceEmail: z.string().nullable(),
  invoiceEmailComplete: z.boolean().nullable(),
  paymentPlan: z.nativeEnum(PaymentFrequency).nullable(),
  invoiceDate: z.nativeEnum(InvoiceFrequency).nullable(),
  sectionComplete: z.boolean().nullable(),
});
